import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import React from "react";

export const Spinner: React.FC = () => {
  return (
    <Box sx={{ display: "flex", justifyContent: "center", marginTop: "30px" }}>
      <CircularProgress />
    </Box>
  );
};
